export interface IProps {
    /** Usually a heroicon, sized by the caller. */
    icon: React.ReactNode;
    /** Background and foreground classes for the mark behind the icon. */
    tint: string;
    title: string;
    /**
     * The first line carries the outcome and is set in dark text; the rest are
     * the qualifications and sit back in grey.
     */
    lines: string[];
    /** Anything that belongs inside the card under the text. */
    children?: React.ReactNode;
}

export const testId = 'OutcomeCard';

/**
 * The card the journey's terminal and near-terminal screens share — initial
 * check, affordability fail, referred and declined.
 *
 * They were four copies of the same markup drifting apart by a few pixels
 * each; the differences that matter are the mark, the wording and whatever
 * sits underneath.
 */
export function OutcomeCard({
    icon,
    tint,
    title,
    lines,
    children,
}: IProps): JSX.Element {
    return (
        <div
            data-testid={testId}
            className='bg-white border border-cardEdge rounded-2xl p-5 _flex flex-col gap-3.5 mt-4'
        >
            <div className={`h-12 w-12 rounded-full flex-center ${tint}`}>
                {icon}
            </div>
            <h3 className='text-[22px] font-bold text-panel'>{title}</h3>
            {lines.map((line, index) => (
                <p
                    key={line}
                    className={
                        index === 0
                            ? 'text-[15px] font-semibold text-panel'
                            : 'text-sm text-textBody'
                    }
                >
                    {line}
                </p>
            ))}
            {children}
        </div>
    );
}
